import { useEffect, useState } from "react";
import { adminApi } from "@/admin/api";
import { X } from "lucide-react";

const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

export default function Donors() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [detail, setDetail] = useState(null);

  useEffect(() => { adminApi.get("/admin/donors").then((r) => setRows(r.data)).catch(() => {}); }, []);

  const open = async (email) => {
    const { data } = await adminApi.get(`/admin/donors/${encodeURIComponent(email)}`);
    setDetail(data);
  };

  const filtered = rows.filter((r) => `${r.name} ${r.email} ${r.phone}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-5">
      <h1 className="text-xl font-bold text-gray-900">Donors <span className="text-sm font-normal text-gray-400">({rows.length})</span></h1>
      <input data-testid="donor-search" placeholder="Search donors…" value={q} onChange={(e) => setQ(e.target.value)}
             className="w-full max-w-sm py-2 px-3 rounded-lg border border-gray-300 text-sm" />
      <div className="bg-white rounded-xl border border-gray-200 overflow-x-auto">
        <table className="w-full text-sm" data-testid="donors-table">
          <thead className="bg-gray-50 text-left text-xs uppercase tracking-wider text-gray-500">
            <tr><th className="p-3">Name</th><th className="p-3">Email</th><th className="p-3">Phone</th><th className="p-3">Total</th><th className="p-3">#</th><th className="p-3">First</th><th className="p-3">Last</th></tr>
          </thead>
          <tbody>
            {filtered.map((r) => (
              <tr key={r.email} onClick={() => open(r.email)} className="border-t border-gray-100 hover:bg-gray-50 cursor-pointer" data-testid={`donor-row`}>
                <td className="p-3 font-medium text-gray-800">{r.name}</td>
                <td className="p-3">{r.email}</td>
                <td className="p-3">{r.phone}</td>
                <td className="p-3 font-semibold text-[hsl(13_65%_44%)]">{inr(r.total)}</td>
                <td className="p-3">{r.count}</td>
                <td className="p-3 text-xs text-gray-500">{new Date(r.first).toLocaleDateString("en-IN")}</td>
                <td className="p-3 text-xs text-gray-500">{new Date(r.last).toLocaleDateString("en-IN")}</td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan="7" className="p-8 text-center text-gray-400">No donors yet.</td></tr>}
          </tbody>
        </table>
      </div>

      {detail && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={() => setDetail(null)}>
          <div className="bg-white rounded-2xl p-6 w-full max-w-lg max-h-[80vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-semibold text-gray-900">{detail.email}</h2>
              <button onClick={() => setDetail(null)}><X size={18} /></button>
            </div>
            <div className="space-y-2">
              {detail.history.map((h) => (
                <div key={h.id} className="flex items-center justify-between text-sm border-b border-gray-100 pb-2">
                  <div><div className="text-gray-800">{h.cause}</div><div className="text-xs text-gray-400">{new Date(h.created_at).toLocaleString("en-IN")} · {h.status}</div></div>
                  <div className="font-semibold text-[hsl(13_65%_44%)]">{inr(h.amount)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
